export default {
    helpText: '所有者になるユーザーは、「本メールアドレス」の認証が必要です。',
    label: '所有者',
    subtitle: 'この会社の所有権をほかのメンバーに譲渡が可能です。',
    title: '所有者を変更',
};
